module.exports = __webpack_public_path__ + "img/euro-tax.ro.cf34f3c8.svg";